<script>
	import { goto } from '$app/navigation';
	import { variables } from '$lib/variables';
	import AuthPhone from '$lib/components/AuthPhone.svelte';

	import Alert from '$lib/components/NotAler.svelte';
	import { env } from '$env/dynamic/public';
	import { browser } from '$app/environment';
	import TeleGramAuth from '$lib/components/TeleGramAuth.svelte';
	import { onDestroy, onMount } from 'svelte';
	import { page } from '$app/stores';
	import { clickOutside } from '$lib/utils/click_outside';

	export let signin;
	const base = variables.basePathApi;
	let authData = {
		email: '',
		password: ''
	};
	let authError = {
		email: '',
		password: ''
	};
	let valid = true;

	function isEmailValid(email) {
		const emailRegexp = new RegExp(
			/^[a-zA-Z0-9][\-_\.\+\!\#\$\%\&\'\*\/\=\?\^\`\{\|]{0,1}([a-zA-Z0-9][\-_\.\+\!\#\$\%\&\'\*\/\=\?\^\`\{\|]{0,1})*[a-zA-Z0-9]@[a-zA-Z0-9][-\.]{0,1}([a-zA-Z][-\.]{0,1})*[a-zA-Z0-9]\.[a-zA-Z0-9]{1,}([\.\-]{0,1}[a-zA-Z]){0,}[a-zA-Z0-9]{0,}$/i
		);

		return emailRegexp.test(email);
	}
	function checkPassword(str) {
		var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
		return re.test(str);
	}
	async function getUserAuth(token) {
		let url = `${variables.basePathApi}/users/customusers/me/`;

		const res = await fetch(url, {
			headers: {
				Authorization: 'Bearer ' + token
			}
		});
		let user = null;
		if (res.status == 200) {
			user = await res.json();
			localStorage.setItem('user', JSON.stringify(user));
			location.href = '/profile';
		}

		return user;
	}
	function ServerAuth(authData) {
		fetch(`/auth/sign-in/login`, {
			method: 'POST',
			body: JSON.stringify(authData)
		})
			.then((response) => {})
			.then((data) => {
				setTimeout(() => {
					location.href = '/profile';
				}, 500);
			})
			.catch((error) => {
				console.error('Ошибка при отправке запроса2:', error);
			});
	}
	async function SignIAn() {
		valid = true;
		if (!authData.email.trim()) {
			authError.email = 'обязательное поле';
		} else {
			authError.email = '';
		}
		// if(!authData.password.trim()){
		//   authError.password = 'обязательное поле'
		// }else{
		//   if(authData.password.length < 8 ){

		//     authError.password = 'пароль не менее 8 символов'
		//   }else{
		//     if(!checkPassword(authData.password)){
		//       authError.password =  'пароль должен содержать  одну цифру и один специальный символ'
		//     }else{
		//       authError.password = ''
		//     }

		//   }

		// }
		if (!authData.password.trim()) {
			authError.password = 'обязательное поле';
		} else {
			authError.password = '';
		}
		if (authError.email.length) {
			valid = false;
		}
		if (authError.password.length) {
			valid = false;
		}

		if (valid) {
			let url = `${variables.basePathApi}/users/login/`;

			const res = await fetch(url, {
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(authData)
			});
			if (res.status == 200) {
				const data = await res.json();
				let authData = {
					access: data.access,
					refresh: data.refresh
				};
				// ServerAuth(authData);
				getUserAuth(data.access);
				// const resLogin = await fetch('/auth/sign-in/login', {
				// 	method: 'POST',
				// 	headers: {
				// 		Accept: 'application/json',
				// 		'Content-Type': 'application/json'
				// 	},
				// 	body: JSON.stringify(json)
				// });
				// if (resLogin.status == 200) {

				// }
				// Cookies.set('access', json.access, { expires: 1 });
				// Cookies.set('refresh', json.refresh, { expires: 1 });
				// setTimeout(() => {
				// 	location.href = '/profile';
				// }, 200);
			} else {
				const json = await res.json();

				alertMessage = true;
				textalert = json.detail;
				color = 'red';
			}
		}
	}
	let alertMessage = false;
	let textalert = '';
	let color = 'rgb(240 253 244)';
	function OnTeleBotAuth(user) {}
	async function SendYandexAuth(authData) {
		let url = `${variables.basePathApi}/users/auth/yandex/`;

		const res = await fetch(url, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(authData)
		});
		if (res.status == 200) {
			const json = await res.json();

			const resLogin = await fetch('/auth/login', {
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(json)
			});
			if (resLogin.status == 200) {
			}
			// Cookies.set('access', json.access, { expires: 1 });
			// Cookies.set('refresh', json.refresh, { expires: 1 });
			setTimeout(() => {
				let urlred = $page.url.searchParams.get('pathname') || '/';
				if ($page.url.searchParams.get('open_basket')) {
					urlred = `${urlred}?open_basket=1`;
				}
				location.href = urlred;
			}, 200);
		} else {
			alert('Ошибка сервера');
		}
	}
	/**
	 * @param {any} authData
	 */
	async function SendGoogleAuth(authData) {
		let url = `${variables.basePathApi}/users/auth/google/`;

		const res = await fetch(url, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(authData)
		});
		if (res.status == 200) {
			const json = await res.json();

			const resLogin = await fetch('/auth/login', {
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(json)
			});
			if (resLogin.status == 200) {
				setTimeout(() => {
					let urlred = $page.url.searchParams.get('pathname') || '/';
					if ($page.url.searchParams.get('open_basket')) {
						urlred = `${urlred}?open_basket=1`;
					}
					location.href = urlred;
				}, 200);
			}
		} else {
			alert('Ошибка сервера');
		}
	}
	async function getAuthUser(access_token) {
		let url = `https://login.yandex.ru/info?format=json&jwt_secret=d73d506cda5a43c58ff871d16148dc1b&oauth_token=${access_token}`;

		const res = await fetch(url, {
			// headers: {
			// 	Authorization:
			// }
		});

		let data = await res.json();
		if (data) {
			await SendYandexAuth(data);
		}
	}
	function decodeJwtResponse(token) {
		var base64Url = token.split('.')[1];
		var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		var jsonPayload = decodeURIComponent(
			window
				.atob(base64)
				.split('')
				.map(function (c) {
					return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
				})
				.join('')
		);

		return JSON.parse(jsonPayload);
	}
	let script;
	let googleSignInScript;

	onMount(async () => {
		// script = document.createElement('script');
		// script.src =
		// 	'https://yastatic.net/s3/passport-sdk/autofill/v1/sdk-suggest-with-polyfills-latest.js';
		// document.body.appendChild(script);
		googleSignInScript = document.createElement('script');
		googleSignInScript.src = `https://accounts.google.com/gsi/client?redirect_uri=${variables.ResdirectGoogleAuth}?pathname=/cart`;
		googleSignInScript.async = true;
		googleSignInScript.defer = true;
		document.body.appendChild(googleSignInScript);
		setTimeout(() => {
			let redirect_uri = 'https://iloveitalianbags.ru/auth/yandex-auth';
			if ($page.data.host === 'ARM') {
				redirect_uri = 'https://arm.iloveitalianbags.ru/auth/yandex-auth';
			}
			YaAuthSuggest.init(
				{
					client_id: 'cfe62ebc9c724de4b6767517a4e5be70',
					response_type: 'token',
					redirect_uri: redirect_uri
				},
				'https://iloveitalianbags.ru',
				{
					view: 'button',
					parentId: 'container-yandex',
					buttonView: 'main',
					buttonTheme: 'light',
					buttonSize: 'm',
					buttonBorderRadius: 0
				}
			)

				.then(({ handler }) => handler())
				.then((data) => {
					getAuthUser(data.access_token);
				})
				.catch((error) => console.log('Обработка ошибки', error));
		}, 1000);

		window.onSignIn = function (response) {
			const responsePayload = decodeJwtResponse(response.credential);

			SendGoogleAuth(responsePayload);
		};
	});
	onDestroy(() => {
		if (script && script.parentNode) {
			script.parentNode.removeChild(script);
		}
		if (googleSignInScript && googleSignInScript.parentNode) {
			googleSignInScript.parentNode.removeChild(googleSignInScript);
		}
	});
</script>

<div class="relative z-[3000]" aria-labelledby="modal-title" role="dialog" aria-modal="true">
	<div class="fixed z-[3000] inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

	<div class="fixed z-[4000] inset-0 w-screen overflow-y-auto">
		<div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
			<div
				use:clickOutside
				on:outclick={() => (signin = false)}
				class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all w-full md:w-max sm:p-6"
			>
				<div class="w-full text-right">
					<button
						on:click={() => {
							signin = false;
						}}
						type="button"
						class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
					>
						<span class="sr-only">Close panel</span>
						<svg
							class="h-6 w-6"
							fill="none"
							viewBox="0 0 24 24"
							stroke-width="1.5"
							stroke="currentColor"
							aria-hidden="true"
						>
							<path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
						</svg>
					</button>
					<div class="sm:mx-auto sm:w-full sm:max-w-md">
						<h6 class="mt-6 text-center text-2xl font-bold tracking-tight text-gray-900">
							{#if $page.data.host === 'ARM'}
								Շարունակելու համար մուտք գործեք ձեր հաշիվ
							{:else}
								Войдите в свою учетную запись чтобы продолжить
							{/if}
						</h6>
					</div>
					<div class="mt-8 relative sm:mx-auto sm:w-full sm:max-w-md">
						<AuthPhone />
					</div>

					<div class="mt-8 relative sm:mx-auto sm:w-full sm:max-w-md">
						{#if alertMessage}
							<Alert bind:alertMessage bind:textalert bind:color />
						{/if}
						<div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
							<div class="mt-10 mb-6 sm:mx-auto sm:w-full sm:max-w-[480px]">
								<div class="bg-white dark:bg-slate-800 px-6 py-12 shadow sm:rounded-lg sm:px-12">
									<form class="space-y-6" action="#" method="POST">
										<div class=" flex justify-center">
											{#if browser}
												<TeleGramAuth />
											{/if}
										</div>
										<div class="flex justify-center">
											<div
												id="g_id_onload"
												data-client_id="884957832990-v5gtflinfpo5fj0u2t9qtqhsgdefbqmn.apps.googleusercontent.com"
												data-context="signin"
												data-ux_mode="popup"
												data-callback="onSignIn"
												data-auto_prompt="false"
											/>

											<div
												class="g_id_signin"
												data-type="standard"
												data-shape="rectangular"
												data-theme="outline"
												data-text="signin_with"
												data-size="large"
												data-logo_alignment="left"
											/>
										</div>

										<div class="mt-6 flex justify-center">
											<div id="container-yandex" class="w-[225px]" />
										</div>
									</form>
								</div>
							</div>
							<form
								on:submit|preventDefault={() => {
									SignIAn();
								}}
								class="space-y-6"
								action="#"
								method="POST"
							>
								<div class="relative">
									<div class="absolute inset-0 flex items-center" aria-hidden="true">
										<div class="w-full border-t border-gray-200" />
									</div>
									<div class="relative flex justify-center text-sm font-medium leading-6">
										<span class="bg-white px-6 text-gray-900">
											{#if $page.data.host === 'ARM'}
												կամ
											{:else}
												или
											{/if}
										</span>
									</div>
								</div>

								<div>
									<label for="email" class="block text-sm font-medium text-gray-700">Email </label>
									<div class="mt-1">
										<input
											class:border-red-300={authError.email}
											bind:value={authData.email}
											id="email"
											name="email"
											type="text"
											autocomplete="email"
											class="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
										/>
										{#if authError.email}
											<span style="color:red" class="text-red-500">{authError.email}</span>
										{/if}
									</div>
								</div>

								<div>
									<label for="password" class="block text-sm font-medium text-gray-700">
										{#if $page.data.host === 'ARM'}
											Գաղտնաբառ
										{:else}
											Пароль
										{/if}
									</label>
									<div class="mt-1">
										<input
											class:border-red-300={authError.password}
											bind:value={authData.password}
											id="password"
											name="password"
											type="password"
											autocomplete="current-password"
											class="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
										/>
										{#if authError.password}
											<span style="color:red" class="text-red-500">{authError.password}</span>
										{/if}
									</div>
								</div>

								<div class="flex items-center justify-between">
									<div class="flex items-center" />

									<div class="text-sm flex flex-col">
										<a
											href="/auth/reset-password"
											class="font-medium text-indigo-600 hover:text-indigo-500"
										>
											{#if $page.data.host === 'ARM'}
												Մոռացել եք Ձեր գաղտնաբառը?
											{:else}
												Забыли пароль?
											{/if}
										</a>

										<a
											href="/auth/sign-up"
											class="font-medium mt-4 text-right text-indigo-600 hover:text-indigo-500"
										>
											{#if $page.data.host === 'ARM'}
												Գրանցում?
											{:else}
												Регистрация?
											{/if}</a
										>
									</div>
								</div>

								<div>
									<button
										type="submit"
										class="flex w-full justify-center rounded-md border border-transparent bg-gray-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
									>
										{#if $page.data.host === 'ARM'}
											Ներս մտնել
										{:else}
											Войти
										{/if}
									</button>
									<!-- <div class="mt-6 flex justify-center">
                      <span>или</span>
                    </div> -->
									<!-- <div class="mt-6 flex justify-center">
                      {#if browser}
                        <script
                          async
                          src="https://telegram.org/js/telegram-widget.js?21"
                          data-telegram-login="TwcryptoBot"
                          data-size="large"
                          data-auth-url="/auth/sign-in/login/telegram/"
                          data-request-access="write"
                        ></script>
                      {/if}
                    </div> -->
								</div>
							</form>
							<p class="text-[12px] mt-4 text-gray-600">
								{#if $page.data.host === 'ARM'}
									Եթե ​​​​հաշիվն արդեն գոյություն ունի, եթե նախկինում գնումներ եք կատարել որոշակի
									էլ.փոստից , սեղմեք մուտք կամ վերականգնեք ձեր գաղտնաբառը, եթե այն չգիտեք կամ
									մոռացել եք:
								{:else}
									Если аккаунт уже существует.Если вы делали ранее покупки с определенного Email
									,нажмите вход или востановить пароль, если вы его не знаете или забыли.
								{/if}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
